<template>
  <div>
    <section>
      <div :style="{ margin: '-4px' }">
        <v-layout align-center>
          <v-flex shrink class="pa-1">
            <ToggleButton
              v-model="form.enable_sale_type"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            />
          </v-flex>
          <v-flex class="pa-1">Sale type</v-flex>
        </v-layout>
      </div>
      <v-card v-if="form.enable_sale_type" :elevation="1" class="mt-2">
        <v-card-text>
          <div>
            <label for="defaultCurrency">Default currency</label>
            <v-autocomplete
              id="defaultCurrency"
              v-model="form.default_currency"
              :items="$store.state.currencies"
              hide-details
              outline
              single-line
            />
          </div>
        </v-card-text>
      </v-card>
    </section>
    <div class="mt-3">
      <v-layout justify-center wrap>
        <v-flex shrink>
          <v-btn outline color="grey" :disabled="isLoading" @click="$emit('close')">{{
            $t('cancel')
          }}</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn depressed color="primary" :loading="isLoading" @click="save">{{
            $t('Save')
          }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import ticket3PageApi from '@/api/ticket3/page'
import { handleApiError } from '@/api/util'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: { ToggleButton },
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      form: {
        enable_sale_type: false,
        default_currency: 'THB',
        ...this.value
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    ...mapState({
      botlist: 'botlist'
    })
  },
  methods: {
    ...mapActions({
      selectBot: 'selectBot',
      updateBotlist: 'updateBotlist'
    }),
    async save() {
      try {
        this.isLoading = true

        const response = await ticket3PageApi.putTicketConfig({
          data: {
            page_id: this.selectedBot.pageid,
            ticket_config: {
              ...this.form,
              default_currency: this.form.enable_sale_type ? this.form.default_currency : 'THB'
            }
          }
        })

        if (response.status === 204) {
          const currentBotIndex = this.botlist.findIndex(
            ({ pageid }) => pageid === this.selectedBot.pageid
          )

          if (currentBotIndex === -1) return

          const currentBot = this.botlist[currentBotIndex]

          const newBot = {
            ...currentBot,
            ticket_v3_config: { ...this.form }
          }
          const newBotList = this.botlist.splice(currentBotIndex, 1, newBot)

          this.updateBotlist(newBotList)
          this.selectBot(newBot)

          this.$emit('close')
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/TicketTypeManagement.vue